import { useAuth0 } from '@auth0/auth0-react';
import { RootState } from '@store/reducers';
import React, { ComponentType, ReactElement, useEffect } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { Button, LoadingTento, Text, useIsInIframe } from 'shared-components';
import { useApplyWizardContext } from '../context/ApplyWizardContext';
import { ApplyWizardSteps, STEP_INTEGRATED_LOGIN } from '@components/ApplyWizard/ApplyWizardSteps';
import { useHistory } from 'react-router-dom';
import { formValueSelector, reset } from 'redux-form';

export const ensureLeadIds = <P extends object>(WrappedComponent?: ComponentType<P>) => {
  const selector = formValueSelector('application');

  const mapStateToProps = (state: RootState) => {
    return {
      user: state.user,
      business_lead_id: selector(state, 'business_lead_id'),
      owner_1_lead_id: selector(state, 'owner_1_lead_id'),
      isNotAnOwner: selector(state, 'isNotAnOwner'),
    };
  };

  const connector = connect(mapStateToProps);
  type PropsFromRedux = ConnectedProps<typeof connector>;
  interface EnsureLeadIdsPresentProps extends PropsFromRedux {
    WrappedComponent: ComponentType<any>;
  }

  const EnsureLeadIdsPresent: React.FC<EnsureLeadIdsPresentProps> = (props) => {
    const { user, business_lead_id, owner_1_lead_id, isNotAnOwner, ...rest } = props;
    const history = useHistory();

    useEffect(() => {
      if ((!owner_1_lead_id || !business_lead_id) && !isNotAnOwner) {
        history.push('/eq/your-information');
      }
    }, [owner_1_lead_id, business_lead_id, isNotAnOwner]);

    return (!owner_1_lead_id || !business_lead_id) && !isNotAnOwner ? (
      <>
        <LoadingTento />
      </>
    ) : WrappedComponent ? (
      <WrappedComponent {...(rest as P)} />
    ) : null;
  };

  return connector(EnsureLeadIdsPresent);
};
